const SelectInput = ({
  id,
  options,
  disabled,
  register,
  label,
  value: selectedOption,
  placeholder,
  isRequired,
  classNames,
  ...attrs
}) => {
  const valueToUse = !options.length || attrs.disabled ? '' : selectedOption;

  const setOption = (value, text) => {
    const isDisabled = disabled && disabled.includes(value);
    return (
      <option key={value} value={value} disabled={isDisabled}>
        {text || value}
      </option>
    );
  };

  const isDisabled = !options.length || attrs.disabled;

  const renderOptions = () => {
    const [first] = options;
    if (typeof first === 'string') {
      return options.map(option => setOption(option));
    }
    if (first instanceof Array) {
      return options.map(([value, text]) => setOption(value, text));
    }
  };

  return (
    <div className="form-field form-field--select">
      <select
        id={id}
        disabled={isDisabled}
        defaultValue=""
        value={valueToUse}
        {...register(id)}
        className={classNames}>
        <option key="" value="">
          {!isDisabled && placeholder}
        </option>

        {renderOptions()}
      </select>
    </div>
  );
};

SelectInput.defaultProps = {
  placeholder: 'Please Choose...',
  disabled: [],
  error: false,
  keys: [],
  label: '',
  options: [],
  required: false,
  selected: '',
  validationMessage: 'This field is required'
};

export default SelectInput;
